import type { DayTradeType } from '@/models/enums';

interface TradeTypeBadgeProps {
  type: DayTradeType;
}

export default function TradeTypeBadge({ type }: TradeTypeBadgeProps) {
  const isLong = type === 'LONG';

  return (
    <span
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-bold uppercase tracking-wide ${
        isLong
          ? 'bg-green-100 text-green-700 dark:bg-green-900/50 dark:text-green-500'
          : 'bg-red-100 text-red-700 dark:bg-red-900/50 dark:text-red-500'
      }`}
    >
      {isLong ? '▲' : '▼'} {type}
    </span>
  );
}
